<template>
<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <router-link to="/" class="block mx-auto w-48">
      <img src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
    </router-link>
    <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
      Sign in
    </h2>
    <p class="mt-2 text-center text-sm text-gray-600 max-w">
      Not a member yet?
      <router-link to="/sign-up" class="font-medium text-blue-600 hover:text-blue-500">
        Sign up
      </router-link>
    </p>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <form @submit.prevent="onSignIn" class="space-y-6">

        <!-- This example requires Tailwind CSS v2.0+ -->
        <div v-if="showSessionExpired" class="rounded-md bg-red-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <heroicon icon="x-circle" type="solid" class="w-5 h-5 text-red-400"></heroicon>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-red-800">
                        You have been signed out. Please sign in again to continue.
                    </h3>
                </div>
            </div>
        </div>


        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div class="mt-1">
            <input v-model="username" id="email" name="email" type="email" autocomplete="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.username.$dirty && !$v.username.required" class="mt-2 text-sm text-red-600">Please enter your email address.</p>
          <p v-if="$v.username.$dirty && !$v.username.email" class="mt-2 text-sm text-red-600">Please enter a valid email address.</p>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Password
          </label>
          <div class="mt-1">
            <input v-model="password" id="password" name="password" type="password" autocomplete="current-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          </div>
          <p v-if="$v.password.$dirty && !$v.password.required" class="mt-2 text-sm text-red-600">Please enter your password.</p>
          <p v-if="$v.password.$dirty && !$v.password.minLength" class="mt-2 text-sm text-red-600">Password must be at least 6 characters.</p>
        </div>

        <div>
            <tti-button type="submit" :loading="submitting" :disabled="submitting" class="w-full justify-center">Sign in</tti-button>
        </div>

        <p v-if="invalidLogin" class="mt- text-sm text-red-600">Sorry, we can’t find an account with this email address and password. Please try again or <router-link to="/sign-up" class="text-blue-600 underline">sign up for an account</router-link>.</p>

        <div class="flex items-center justify-end">
          <!-- <div class="flex items-center">
            <input id="remember_me" name="remember_me" type="checkbox" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
            <label for="remember_me" class="ml-2 block text-sm text-gray-900">
              Remember me
            </label>
          </div> -->

          <div class="text-sm">
            <router-link to="/forgot-password" class="font-medium text-blue-600 hover:text-blue-500">
              Forgot your password?
            </router-link>
          </div>
        </div>

        
      </form>

    </div>
  </div>
</div>


</template>
<script>

import { required, email, minLength } from 'vuelidate/lib/validators';

import AuthService from '../services/AuthServices';
const authService = new AuthService();

export default {
    components: {
        'heroicon': () => import('./Heroicon'),
        'tti-button': () => import('./TailwindButton')
    },
    data() {
        return {
            username: null,
            password: null,
            submitting: false,
            invalidLogin: false
        }
    },
    validations: {
      username: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      }
    },
    computed: {
        showSessionExpired() {
            return this.$route.query?.expired !== null && this.$route.query?.expired !== undefined;
        }
    },
    methods: {
        onSignIn() {
            this.invalidLogin = false;

            this.$v.$touch();
            if (this.$v.$invalid) return;

            this.submitting = true;

            authService.signIn(this.username, this.password)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('token', response.data.token);
                        this.$router.push('/my-account/');
                    }
                })
                .catch(() => {
                    this.invalidLogin = true;
                })
                .finally(() => {
                    this.submitting = false;
                });
        }
    }
}
</script>